import * as React from "react";
import { Field } from "formik";
import { InputOTPField } from "../../shared/InputOTPField";
import { ViewMe } from "@njoy/controller";
import Loader from "../../../components/loader/Loader";
import AntAvatar from "../../shared/AntAvatar";

interface Page2Props {
  firstname: string;
  lastname: string;
}

export const Page2: React.FC<Page2Props> = ({ firstname, lastname }) => (
  <ViewMe>
    {data => {
      if (!data.match) {
        return <Loader center text="Loading..." noLeftMargin />;
      }

      return (
        <>
          <div className="flex flex-row justify-between items-center">
            <div>
              {/* Navigation button if needed */}
            </div>
          </div>

          <div className="my-10 flex justify-center flex-col items-center space-y-6">
            <AntAvatar 
            firstname={firstname}
            lastname={lastname} />

            <h1 className="text-white text-2xl">
              Hello, {firstname}
            </h1>

            <h3 className="text-lg mt-5 font-bold text-white">Set your PIN</h3>
            <p className="text-medium font-normal text-white">
              Secure your account with a 4-digit pin.
            </p>
          </div>

          <Field 
          name="pin" 
          otpLength={4} 
          component={InputOTPField} />
        </>
      );
    }}
  </ViewMe>
);